module.exports = "/10edfd4068d34c50b2112484a9ac70e4d00b19fd/efd36fc8af90b031c417299418dda296.svg";